module.exports = __webpack_public_path__ + "img/upgrade.0124594e.svg";